import { render, staticRenderFns } from "./CatalogProductImages.vue?vue&type=template&id=6d6e3f2c&scoped=true&"
import script from "./CatalogProductImages.vue?vue&type=script&lang=js&"
export * from "./CatalogProductImages.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductImages.vue?vue&type=style&index=0&id=6d6e3f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e3f2c",
  null
  
)

export default component.exports